var _path, _path2, _rect, _path3, _path4, _path5, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTestTubeOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 63,
    viewBox: "0 0 34 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.375 20.2881H10.625C10.625 20.2881 10.625 37.3728 10.625 41.644C10.625 45.9152 14.4583 60.9058 14.4583 60.9058C14.7006 62.1235 15.7644 62.9999 17 62.9999C18.2356 62.9999 19.2995 62.1235 19.5418 60.9058C19.5418 60.9058 23.375 45.9152 23.375 41.644C23.375 37.3728 23.375 20.2881 23.375 20.2881Z",
    fill: "#868CA6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3125 21.3558H11.6875C11.6875 21.3558 11.6875 37.3728 11.6875 41.644C11.6875 45.9152 15.0875 59.7965 15.0875 59.7965C15.2895 60.9533 15.9704 61.9321 17 61.9321C18.0297 61.9321 18.7106 60.9533 18.9125 59.7965C18.9125 59.7965 22.3125 45.9152 22.3125 41.644C22.3125 37.3728 22.3125 21.3558 22.3125 21.3558Z",
    fill: "#CBCDD8"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.50003,
    y: 20.2881,
    width: 17.5312,
    height: 2.13559,
    rx: 1.0678,
    fill: "#868CA6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3125 22.4237H19.125C19.125 22.4237 19.125 37.3729 19.125 41.644C19.125 46.6459 15.4442 60.8644 15.4442 60.8644C15.7821 61.4972 16.3135 61.9322 17 61.9322C18.0296 61.9322 18.7105 60.9534 18.9125 59.7966C18.9125 59.7966 22.3125 45.9152 22.3125 41.644C22.3125 37.3729 22.3125 22.4237 22.3125 22.4237Z",
    fill: "black",
    fillOpacity: 0.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4637 5.4679L27.5436 15.7347L25.9274 15.2704C25.3966 15.1179 25.0888 14.5636 25.2399 14.0324L27.6129 5.68936C27.764 5.15815 28.3168 4.85113 28.8476 5.00362L30.4637 5.4679Z",
    fill: "#577898"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.7116 1.64663C33.2736 1.81609 33.5926 2.41137 33.4239 2.97623L28.6537 18.9561C28.6535 18.9571 28.6533 18.958 28.6531 18.959C28.6458 18.9902 28.6358 19.0312 28.6224 19.0808C28.5957 19.1796 28.5555 19.3135 28.498 19.471C28.3842 19.783 28.1963 20.2049 27.8978 20.6334C27.2838 21.5149 26.1908 22.4236 24.4375 22.4236L24.4375 20.288C25.3405 20.288 25.8412 19.862 26.1569 19.4087C26.3233 19.1699 26.4341 18.9244 26.5029 18.7359C26.5368 18.6431 26.5588 18.5685 26.5716 18.5213C26.5779 18.4979 26.5818 18.4816 26.5837 18.4737C26.584 18.4723 26.5842 18.4713 26.5844 18.4704L26.5929 18.4277L31.3886 2.36257C31.5572 1.79771 32.1495 1.47718 32.7116 1.64663Z",
    fill: "#868CA6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.625,
    y: 26.6949,
    width: 12.75,
    height: 12.8136,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 19.125,
    y: 26.6949,
    width: 4.25,
    height: 12.8136,
    fill: "black",
    fillOpacity: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestTubeOpen);
export default __webpack_public_path__ + "static/media/test_tube_open.4ab1a449c5b5f1686ae822bfdf9fb6d9.svg";
export { ForwardRef as ReactComponent };